import { FileUploader, Form, Popup } from "devextreme-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDataSource } from "../../../../contexts/dataSource";
import { GroupItem, Label, RequiredRule, SimpleItem } from "devextreme-react/cjs/form";
import { ToolbarItem } from "devextreme-react/cjs/popup";
import notify from "devextreme/ui/notify";
import useAxiosPrivate, { axiosHrPrivate } from "../../../../api/useAxios";

export function EmployeDocumentCardPopup({ employeeId, loadId, visible, setVisible, onHiding, onAfterAdd }) {
    const [formData, setFormData] = useState(
        {
            "employeeId": employeeId,
            "employeeDocumentInfoId": null,
            "description": null,
            "file": null,
        },)
    const [selectedFile, setSelectedFile] = useState([])
    const [sending, setSending] = useState(false)
    const { dataSourceHR } = useDataSource()
    const axiosPrivate = useAxiosPrivate(axiosHrPrivate)

    const handleFieldDataChanged = (e) => {
        //setDirty(true)
    }

    const handleSubmit = useCallback(async (e) => {
        
        const data = new FormData()
        data.append("employeeId", employeeId)
        data.append("employeeDocumentInfoId", formData.employeeDocumentInfoId)
        data.append("description", formData.description)
        data.append('file', selectedFile[0]);

        const axiosOptions = {
            method: formData.id ? "put" : "post",
            url: "/api/EmployeeDocument/FormData",
            data: data
        }
        try {
            setSending(true)
            const response = await axiosPrivate(axiosOptions)
            setSending(false)
            if (response?.status === 201) {
                if (!formData.id)
                    if (response.data?.data?.id) {
                        setFormData((prev) => {
                            return {
                                ...prev,
                                id: response.data.data.id
                            }
                        })
                    }
            }

            if (response?.status === 201 || response?.status === 200) {
                notify("İşlem başarılı", "success")
                onAfterAdd && onAfterAdd()
                setVisible(false)                
            }
        } catch (error) {
            notify("Bir hata oluştu. Kayıt başarısız.", "danger")
            //console.log(error)
            setSending(false)
        }
        setSending(false)
    }, [formData, employeeId, selectedFile, axiosPrivate])

    const dbEmployeeDocumentInfo = useMemo(() => dataSourceHR({
        loadUrl: "/api/EmployeeDocumentInfo"

    }), [dataSourceHR])

    const employeeDocumentInfoOptions = useMemo(() => ({
        dataSource: dbEmployeeDocumentInfo,
        valueExpr: "id",
        displayExpr: "name"
    }), [dbEmployeeDocumentInfo])

    const onValueChangedFileUpLoader = useCallback((e) => {
        setSelectedFile(e.value)
    }, [])

    const getSaveButtonOptions = useCallback(() => ({
        icon: 'save',
        stylingMode: 'contained',
        text: 'Kaydet',
        onClick: handleSubmit,
        disabled: sending
    }), [handleSubmit, sending]);

    const getCancelButtonOptions = useCallback(() => ({
        icon: 'close',
        stylingMode: 'contained',
        text: 'İptal',
        onClick: () => { setVisible && setVisible(false) },
        disabled: sending,
    }), [setVisible, sending]);

    return (
        <Popup
            showTitle
            title="Belge Kayıt"
            visible={visible}
            onHiding={onHiding}
            hideOnOutsideClick={true}
            width={550}
            height={400}
        >
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={getSaveButtonOptions()}
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={getCancelButtonOptions()}
            />
            <Form
                formData={formData}
                onFieldDataChanged={handleFieldDataChanged}
            >
                <GroupItem >
                    <SimpleItem dataField="employeeDocumentInfoId"
                        editorType="dxSelectBox"
                        editorOptions={employeeDocumentInfoOptions}>
                        <Label text="Döküman Tipi" />
                        <RequiredRule />
                    </SimpleItem>
                    <SimpleItem dataField="description" >
                        <Label text="Açıklama" />
                        <RequiredRule />
                    </SimpleItem>
                    <GroupItem>
                        <FileUploader
                            //inputAttr={fileUploaderLabel}
                            selectButtonText="Bir dosya seçiniz."
                            labelText=""
                            //accept="image/*"
                            uploadMode="useForm"
                            value={selectedFile ?? []}
                            onValueChanged={onValueChangedFileUpLoader}
                        />
                    </GroupItem>
                </GroupItem>
            </Form>
        </Popup>
    )
}
